import { sql } from "drizzle-orm";
import { executeWorkflowV2Query, type WorkflowV2DbLike } from "./workflow-kernel-v2-db.js";

function rowsFromResult<T>(result: unknown): T[] {
  if (Array.isArray(result)) return result as T[];
  if (result && typeof result === "object" && Array.isArray((result as { rows?: unknown[] }).rows)) {
    return (result as { rows: T[] }).rows;
  }
  return [];
}

export async function acquireWorkflowV2CapacityLocks(options: {
  db: WorkflowV2DbLike;
  runId: string;
  globalConcurrency: number | null;
  perUserConcurrency: number | null;
  perWorkflowNameConcurrency: number | null;
}): Promise<void> {
  const result = await executeWorkflowV2Query(
    options.db,
    sql`
        SELECT workflow_name, user_id
        FROM _gencow_workflow_runs_v2
        WHERE id = ${options.runId}
        LIMIT 1
    `,
  );
  const target = rowsFromResult<{ workflow_name: string; user_id: string | null }>(result)[0];
  if (!target) return;

  const scopes = [
    options.globalConcurrency ? "global" : null,
    options.perWorkflowNameConcurrency ? `workflow:${target.workflow_name}` : null,
    options.perUserConcurrency && target.user_id ? `user:${target.user_id}` : null,
  ]
    .filter((scope): scope is string => typeof scope === "string" && scope.length > 0)
    .sort();

  for (const scope of scopes) {
    await executeWorkflowV2Query(
      options.db,
      sql`
        INSERT INTO _gencow_workflow_capacity_locks_v2 (scope, updated_at)
        VALUES (${scope}, NOW())
        ON CONFLICT (scope) DO NOTHING
      `,
    );
  }
  for (const scope of scopes) {
    await executeWorkflowV2Query(
      options.db,
      sql`
        SELECT scope
        FROM _gencow_workflow_capacity_locks_v2
        WHERE scope = ${scope}
        FOR UPDATE
      `,
    );
  }
}
